import { useEffect, useId, useRef } from "react";
import { useTranslation } from "react-i18next";
import { LocalGatewayOsTabs } from "./LocalGatewayOsTabs";
import windowsGuide from "@/assets/local-gateway/windows.svg";
import macosGuide from "@/assets/local-gateway/macos.svg";

export function LocalGatewayConsolePreparation({ os, busy, onOsChange }: {
  os: string;
  busy: boolean;
  onOsChange: (os: string) => void;
}) {
  const { t } = useTranslation("storages");
  const tabId = useId();
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => { heading.current?.focus(); }, []);
  const supported = os === "windows" || os === "darwin";
  return <section className="space-y-4 border-t border-slate-200 pt-4" aria-labelledby="gateway-console-guide">
    <h3 ref={heading} id="gateway-console-guide" tabIndex={-1} className="font-semibold">
      {t("new.consolePreparationTitle")}
    </h3>
    <LocalGatewayOsTabs tabId={tabId} label={t("new.installedOs")} selectedOs={os}
      disabled={busy} onChange={onOsChange} />
    <div role="tabpanel" id={`${tabId}-panel`} aria-labelledby={supported ? `${tabId}-${os}` : undefined}
      className="space-y-4" tabIndex={0}>
    {supported ? <>
      <p className="text-sm leading-6">{t(os === "windows" ? "new.consoleWindowsGuide" : "new.consoleMacGuide")}</p>
      <img key={os} src={os === "windows" ? windowsGuide : macosGuide}
        alt={t(os === "windows" ? "new.consoleWindowsGuide" : "new.consoleMacGuide")}
        className="h-auto w-full max-w-[320px]" onError={event => { event.currentTarget.hidden = true; }} />
      <details className="text-sm leading-6">
        <summary className="cursor-pointer font-medium">{t("new.consoleTroubleTitle")}</summary>
        <p className="pt-2">{t(os === "windows" ? "new.consoleWindowsTrouble" : "new.consoleMacTrouble")}</p>
      </details>
      <p className="text-sm leading-6">{t("new.consolePasswordGuide")}</p>
      <p className="text-sm leading-6">{t("new.consoleReadyGuide")}</p>
    </> : null}
    </div>
  </section>;
}
